import { configureStore } from '@reduxjs/toolkit';
import { battleActions, battleSlice } from './battleSlice';
import { overlaySlice } from './overlaySlice';
import { loadBattleSnapshot, saveBattleSnapshot } from './battlePersistence';

export const store = configureStore({
  reducer: {
    battleSession: battleSlice.reducer,
    overlays: overlaySlice.reducer,
  },
});

const savedBattle = loadBattleSnapshot(localStorage);
if (savedBattle) store.dispatch(battleActions.hydrateBattle(savedBattle));

let timer: ReturnType<typeof setTimeout> | undefined;
const persist = () => {
  saveBattleSnapshot(localStorage, store.getState().battleSession);
};

store.subscribe(() => {
  if (timer) return;
  timer = setTimeout(() => {
    timer = undefined;
    persist();
  }, 200);
});

const flush = () => {
  if (timer) clearTimeout(timer);
  timer = undefined;
  persist();
};

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') flush();
});
window.addEventListener('pagehide', flush);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
